export class CommonBase {

  protected getErrorKey(key: string) {
    return key + ':error'
  }

  protected getMultiErrorKey(key: string, num: number) {
    return key + ':error:' + num
  }

}
